import * as ajax from "../../actions/ajaxCounterActions";
import * as exception from "../../actions/exceptionActions";
import * as domainConstants from "../../constants/DomainConstants";

import geographyApi from "../../api/geographyApi";

import { getStore } from "../../store/configureStore";

import showToastr from "../../util/toastr.js";
import redirector from "../../util/redirector";
import GenerateGuid from "../../util/guid";
import mergeDeep from "../../util/mergeDeep";


export default class SimulatieInfrastructuurDetailPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const infrastructuurId = this.context.props.params.infrastructuurId;
		const isNew = this.context.props.route.params.isNew;
		const mapKey = GenerateGuid();
		const sportinfrastructurenInDeBuurt = this.context.props.sportinfrastructurenInDeBuurt;

		this.context.setState({
			model: null,
			isNew,
			isSpakki: false,
			mapKey,
			mapEditMode: false,
			mapDraggable: false,
			mapCenter: null,
			mapNewCoords: null,
			sportinfrastructurenInDeBuurt: sportinfrastructurenInDeBuurt
		});

		if (isNew) {
			this.getNewInfrastructuur(infrastructuurId);
		}
		else {
			this.getInfrastructuur(infrastructuurId);
		}
	}

	loadLayout() {
		this.context.props.loadLayout();
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	change(event, data) {
		const target = event.target;
		let model = this.context.state.model;

		if (data) {
			const field = data.name;
			model[field] = data.value;
		} else {
			const field = target.name;
			model[field] = target.value;

			model[field] = target.value;
		}

		this.context.setState({ model: model, hasUnsavedChanges: true });
	}

	getNewInfrastructuur(infrastructuurId) {
		const sportinfrastructurenInDeBuurt = this.context.props.sportinfrastructurenInDeBuurt;
		let model = mergeDeep({}, sportinfrastructurenInDeBuurt.find(x => x.id === infrastructuurId));

		const type = this.context.props.route.params.type;
		model.soortWerken = type;

		this.setStateAfterUpdate(model);
		this.loadLayout();
	}

	getInfrastructuur(infrastructuurId) {
		const sportinfrastructurenInDeBuurt = this.context.props.sportinfrastructurenInDeBuurt;
		let model = mergeDeep({}, sportinfrastructurenInDeBuurt.find(x => x.id === infrastructuurId));

		if (model && model.spakki && model.spakki.id) //SpakkiInfrastructuren moeten type Renovatie zijn.
		{
			model = Object.assign({}, model, { soortWerken: domainConstants.INFRASTRUCTUUR_TYPE.RENOVATIE, locatieGewijzigd: true });
		}

		this.setStateAfterUpdate(model);
		this.loadLayout();
	}

	replacePoint() {
		this.context.setState({
			mapEditMode: true
		});
	}

	onDragEnd(e) {
		const movedMarker = mergeDeep({}, this.context.state.mapNewCoords);

		movedMarker.lat = e.target.getLatLng().lat;
		movedMarker.lng = e.target.getLatLng().lng;

		this.context.setState({
			mapNewCoords: movedMarker
		});
	}

	getGeoCoordinates(event) {
		let model = this.context.state.model;

		let adres = {
			gemeenteId: model.gemeente,
			postcodeId: model.postcode,
			straatHuisnummer: model.straatHuisnummer
		};

		this.dispatch(ajax.started());
		geographyApi.getCoordinatenForAdres(adres)
			.then(result => {
				this.dispatch(ajax.ended());
				const data = result.data;
				if (data.lengtegraad && data.breedtegraad) {
					model.locatieGewijzigd = model.locatieGewijzigd === true || model.locatieGewijzigd === "true" ? model.locatieGewijzigd : (model.lengtegraad != data.lengtegraad || model.breedtegraad != data.breedtegraad);
					model.lengtegraad = data.lengtegraad;
					model.breedtegraad = data.breedtegraad;
					const mapCenter = Object.assign({}, { lat: parseFloat(data.breedtegraad), lng: parseFloat(data.lengtegraad) });
					const mapNewCoords = Object.assign({}, { lat: parseFloat(data.breedtegraad), lng: parseFloat(data.lengtegraad) });

					this.context.setState({
						model,
						mapCenter,
						mapNewCoords
					});
				} else {
					showToastr(domainConstants.NO_GEOCOORDINATEN_FOUND2);
				}
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	save() {
		const model = this.context.state.model;
		model.deelVanAanvraag_original = model.deelVanAanvraag;
		this.context.props.saveInfrastructuur(model)
			.then((notification) => {
				let isSaved = showToastr(notification);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					this.goToOverview();
				}
			});
	}

	cancel() {
		const model = this.context.state.model_original;
		const isNew = this.context.state.isNew;

		if (!isNew) {
			// indien geen nieuwe, dan moeten de waarden ge-reset worden
			model.deelVanAanvraag = model.deelVanAanvraag_original ? model.deelVanAanvraag_original : model.deelVanAanvraag;
			this.context.props.resetInfrastructuurErrors(model);
		}
		else
			this.context.props.removeInfrastructuur(model.id);


		//this.context.setState({ hasUnsavedChanges: false });
		this.goToOverview();
	}

	saveNewPoint() {
		const state = this.context.state;
		const model = Object.assign({}, state.model);
		const newCoordinates = Object.assign({}, state.mapNewCoords);
		model.locatieGewijzigd = model.locatieGewijzigd === true || model.locatieGewijzigd === "true" ? model.locatieGewijzigd : (model.lengtegraad != newCoordinates.lng || model.breedtegraad != newCoordinates.lat);
		model.lengtegraad = newCoordinates.lng;
		model.breedtegraad = newCoordinates.lat;
		this.context.setState({
			mapEditMode: false,
			mapKey: GenerateGuid(),
			model
		});
	}

	cancelReplace() {
		const state = this.context.state;
		const model = state.model;
		let originalCoordinates = Object.assign({}, { lat: parseFloat(model.breedtegraad), lng: parseFloat(model.lengtegraad) });
		this.context.setState({
			mapEditMode: false,
			mapCenter: originalCoordinates,
			mapNewCoords: originalCoordinates
		});
	}

	goToOverview() {
		redirector.goTo(!this.context.props.simulatieDossierId ? 'simulatiedossier/nieuw' : `/simulatiedossier/${this.context.props.simulatieDossierId}`);
	}

	isReadyToRender() {
		if (!this.context.state.model) {
			return false;
		}

		if (!this.context.props.soortenInfrastructuur || !this.context.props.soortenInfrastructuur.length > 0) {
			return false;
		}

		if (!this.context.props.gemeenten || !this.context.props.gemeenten.length > 0) {
			return false;
		}

		if (!this.context.props.postcodes || !this.context.props.postcodes.length > 0) {
			return false;
		}

		return true;
	}

	setStateAfterUpdate(item) {
		const coords = Object.assign({}, { lat: parseFloat(item.breedtegraad), lng: parseFloat(item.lengtegraad) });
		this.context.setState({
			model: item,
			model_original: mergeDeep({}, item),
			mapCenter: coords,
			mapNewCoords: coords,
			isSpakki: !!(item.spakki && item.spakki.id && item.soortWerken.toString() == domainConstants.INFRASTRUCTUUR_TYPE.RENOVATIE)
		});
	}
}